const translation = {
  currentPlan: 'Current Plan',
  upgradeBtn: {
    plain: 'Upgrade Plan',
    encourage: 'Upgrade Now',
    encourageShort: 'Upgrade',
  },
  viewBilling: 'Manage billing and subscriptions',
  buyPermissionDeniedTip:
    'Please contact your enterprise administrator to subscribe',
  plansCommon: {
    title: "Choose a plan that's right for you",
    yearlyTip: 'Get 2 months for free by subscribing yearly!',
    mostPopular: 'Most Popular',
    planRange: {
      monthly: 'Monthly',
      yearly: 'Yearly',
    },
    month: 'month',
    year: 'year',
    save: 'Save ',
    free: 'Free',
    currentPlan: 'Current Plan',
    contractSales: 'Contact sales',
    contractOwner: 'Contact team manager',
    startForFree: 'Start for free',
    getStartedWith: 'Get started with ',
    contactSales: 'Contact Sales',
    talkToSales: 'Talk to Sales',
    modelProviders: 'Model Providers',
    teamMembers: 'Team Members',
    annotationQuota: 'Annotation Quota',
    buildApps: 'Build Apps',
    vectorSpace: 'Vector Space',
    vectorSpaceBillingTooltip:
      'Each 1MB can store about 1.2million characters of vectorized data(estimated using OpenAI Embeddings, varies across models).',
    vectorSpaceTooltip:
      'Vector Space is the long-term memory system required for LLMs  to comprehend your data.',
    documentsUploadQuota: 'Documents Upload Quota',
    documentProcessingPriority: 'Document Processing Priority',
    documentProcessingPriorityTip:
      'For higher document processing priority, please upgrade your plan.',
    documentProcessingPriorityUpgrade:
      'Process more data with higher accuracy at faster speeds.',
    priority: {
      standard: 'Standard',
      priority: 'Priority',
      'top-priority': 'Top Priority',
    },
    logsHistory: 'Logs history',
    customTools: 'Custom Tools',
    unavailable: 'Unavailable',
    days: 'days',
    unlimited: 'Unlimited',
    support: 'Support',
    supportItems: {
      communityForums: 'Community forums',
      emailSupport: 'Email support',
      priorityEmail: 'Priority email & chat support',
      logoChange: 'Logo change',
      SSOAuthentication: 'SSO authentication',
      personalizedSupport: 'Personalized support',
      dedicatedAPISupport: 'Dedicated API support',
      customIntegration: 'Custom integration and support',
      ragAPIRequest: 'RAG API Requests',
      bulkUpload: 'Bulk upload documents',
      agentMode: 'Agent Mode',
      workflow: 'Workflow',
      llmLoadingBalancing: 'LLM Load Balancing',
      llmLoadingBalancingTooltip:
        'Add multiple API keys to models, effectively bypassing the API rate limits. ',
    },
    comingSoon: 'Coming soon',
    member: 'Member',
    memberAfter: 'Member',
    messageRequest: {
      title: 'Message Credits',
      tooltip:
        'Message invocation quotas for various plans using OpenAI models (except gpt4).Messages over the limit will use your OpenAI API Key.',
    },
    annotatedResponse: {
      title: 'Annotation Quota Limits',
      tooltip:
        'Manual editing and annotation of responses provides customizable high-quality question-answering abilities for apps. (Applicable only in chat apps)',
    },
    ragAPIRequestTooltip:
      'Refers to the number of API calls invoking only the knowledge base processing capabilities of Dify.',
    receiptInfo:
      'Only team owner and team admin can subscribe and view billing information',
  },
  plans: {
    sandbox: {
      name: 'Sandbox',
      description: '200 times GPT free trial',
      includesTitle: 'Includes:',
    },
    professional: {
      name: 'Professional',
      description:
        'For individuals and small teams to unlock more power affordably.',
      includesTitle: 'Everything in free plan, plus:',
    },
    team: {
      name: 'Team',
      description: 'Collaborate without limits and enjoy top-tier performance.',
      includesTitle: 'Everything in Professional plan, plus:',
    },
    enterprise: {
      name: 'Enterprise',
      description:
        'Get full capabilities and support for large-scale mission-critical systems.',
      includesTitle: 'Everything in Team plan, plus:',
    },
  },
  vectorSpace: {
    fullTip: 'Vector Space is full.',
    fullSolution: 'Upgrade your plan to get more space.',
  },
  apps: {
    fullTipLine1: 'Upgrade your plan to',
    fullTipLine2: 'build more apps.',
  },
  annotatedResponse: {
    fullTipLine1: 'Upgrade your plan to',
    fullTipLine2: 'annotate more conversations.',
    quotaTitle: 'Annotation Reply Quota',
  },
  payment: {
    method: 'Payment Method',
    channel: 'Top-up Method',
    alipay: 'Alipay',
    confirmPay: 'Confirm Payment',
    cancelOrder: 'Cancel Order',
    balancePay: 'Balance Payment',
  },
  bill: {
    label: {
      availableQuota: 'Available Quota',
      billingPeriod: 'Billing Period',
    },
  },
  fee: {
    orderId: 'Order ID',
    type: 'Type',
    status: 'Status',
    amount: 'Amount',
    product: 'Product',
    createdAt: 'Created At',
    paidAt: 'Paid At',
    action: 'Action',
    detail: 'Detail',
    orderSummary: 'Order Summary',
    orderType: 'Order Type',
    name: 'Name',
    architecture: 'Architecture',
    preferRegion: 'Preferred Region',
    preferZone: 'Preferred Zone',
    createOrder: 'Create Order',
    onlineRecharge: 'Online Recharge',
    rechargeAmount: 'Recharge Amount',
    inputRechargeAmount: 'Please enter recharge amount',
    rechargeAmountGreaterThanZero: 'Recharge amount must be greater than 0',
    readAndCheck: 'Please read the following tips and check this item',
    iHaveRead: 'I have read',
    createRechargeOrder: 'Create Recharge Order',
    orderTagType: {},
    invoiceStatus: {},
    monthlyPaid: 'Monthly Paid',
    annualPaid: 'Annual Paid',
    confirm: 'Confirm',
    cancel: 'Cancel',
    date: 'Date',
    ioIn: 'Income',
    ioOut: 'Expense',
    resourceId: 'Resource ID',
    resourceType: 'Resource Type',
    resourceName: 'Resource Name',
  },
  menu: {
    fee: 'Fee',
  },
  accountOverview: {
    title: 'Account Overview',
    availableBalance: 'Available Balance',
    availableBalanceTip:
      'When the available balance is negative, resources may be suspended. To ensure your business runs smoothly, please recharge in time.',
    rechargeButton: 'Recharge',
    invoiceableAmount: 'Invoiceable Amount',
    invoiceableAmountTip:
      'Total amount of bills that have been charged but not yet applied for invoices as of the current date.',
    invoiceButton: 'Apply for Invoice',
    monthlyOverview: 'Monthly Income and Expense Overview',
    chart: {
      income: 'Income',
      expense: 'Expense',
      noData: 'No Data',
      startMonth: 'Start Month',
      endMonth: 'End Month',
    },
  },
  funds: {
    title: 'Transaction Details',
    alert: {
      description1:
        'Transaction details only show income and expense changes in this fund account, including recharge, consumption and other fund changes. To query recharge records separately, you can only check "Recharge" in the transaction type.',
      description2:
        'Transaction details do not include voucher deductions. You can visit',
      voucherManagement: 'Voucher Management',
      voucherDescription: 'to learn about voucher usage details.',
    },
  },
  invoice: {
    title: 'Invoice Management',
    alert: {
      description1: 'After submitting an invoice application, we will complete the invoicing within 5 working days and send it to your email.',
      description2: 'Invoices can only be issued for billed accounts.',
      description3: 'The invoice amount is the actual payment amount and does not include voucher deductions.',
      description4: 'If you need to modify invoice information, please contact customer service.',
    },
    tabs: {
      issue: 'Issue Invoice',
      history: 'Invoice History',
      headers: 'Invoice Headers',
      email: 'Receiving Method',
    },
    history: {
      table: {
        applyTime: 'Application Time (UTC+8)',
        title: 'Invoice Header',
        invoiceType: 'Invoice Type',
        medium: 'Invoice Medium',
        invoiceNumber: 'Invoice Number',
        amount: 'Invoice Amount',
        comment: 'Comment',
        status: 'Status',
        action: 'Action',
        detail: 'Detail',
      },
      status: {
        processing: 'Processing',
        completed: 'Completed',
        failed: 'Failed',
      },
      pagination: {
        total: 'Total {{total}} records',
      },
    },
    issueInvoice: {
      table: {
        month: 'Billing Month',
        documentName: 'Document Name',
        totalAmount: 'Invoice Total',
      },
      pagination: {
        total: 'Total {{total}} items',
      },
      selected: 'Selected {{count}} items, Total Amount: ¥ {{amount}}',
      nextStep: 'Next Step',
    },
    invoicing: {
      title: 'Apply for Invoice',
      steps: {
        selectItems: 'Select Invoice Items',
        confirmInfo: 'Confirm Invoice Information',
        complete: 'Complete',
      },
      customerKeyInfo: 'Customer Key Information',
      customerBasicInfo: 'Customer Basic Information',
      manageTitle: 'Manage Invoice Header Information',
      selectOtherEmail: 'Select Other Email',
      previous: 'Previous',
      submit: 'Submit',
      fields: {
        title: 'Invoice Header',
        issueType: 'Issue Type',
        invoiceType: 'Invoice Type',
        amount: 'Invoice Amount',
        medium: 'Invoice Medium',
        digitalInvoice: 'Digital Invoice',
        digitalInvoiceTooltip: 'Digital Electronic Invoice (referred to as "Digital Invoice"): is the abbreviation of "Fully Digitalized Electronic Invoice", which does not exist in paper form and is a new type of invoice with the same legal effect as paper invoices',
        receiveInfo: 'Receive Information',
        receiveInfoDescription: 'Please select the tax information that needs to be displayed on the invoice. After selection, it will be displayed in the tax information in the invoice remarks column.',
        addressPhone: 'Buyer Address, Phone',
        bankAccount: 'Buyer Bank Name, Bank Account',
        comment: 'Comment',
        commentPlaceholder: 'Please fill in if needed',
        commentWarning: 'The comment information filled in here will be displayed in the content area of the invoice',
      },
      modals: {
        selectEmail: {
          title: 'Select Email',
        },
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      messages: {
        emailRequired: 'Please select email',
        titleRequired: 'Please select invoice header',
        applySuccess: 'Application successful',
      },
    },
    historyDetail: {
      title: 'Invoice Detail',
      fields: {
        title: 'Invoice Header',
        issueType: 'Issue Type',
        invoiceType: 'Invoice Type',
        normalInvoice: 'Normal Invoice',
        vatInvoice: 'VAT Invoice',
        amount: 'Invoice Amount',
        taxRate: 'Tax Amount',
        taxRateValue: '6%',
        medium: 'Invoice Medium',
        comment: 'Comment',
        applyTime: 'Application Time',
        taxInfo: 'Tax Information',
      },
    },
    headers: {
      title: 'Invoice Headers',
      editInfo: 'Edit Invoice Info',
      noHeader: 'No active invoice header, please click',
      management: 'Invoice Header Management',
      toSetup: 'to setup',
      fields: {
        issueType: 'Issue Type',
        company: 'Company',
        personal: 'Personal',
        title: 'Invoice Header',
        invoiceType: 'Invoice Type',
        normalVAT: 'VAT Normal Invoice',
        specialVAT: 'VAT Special Invoice',
        taxNumber: 'Tax Number',
        bankName: 'Bank Name',
        bankAccount: 'Bank Account',
        address: 'Address',
        phone: 'Phone',
        realName: 'Real Name',
        idNumber: 'ID Number',
      },
    },
    titleForm: {
      title: 'Invoice Information',
      tooltips: {
        normalVAT: 'VAT Normal Invoice: The invoicing object does not have general taxpayer qualification, and the invoice cannot be used for input tax deduction.',
        specialVAT: 'VAT Special Invoice: The invoicing object must have general taxpayer qualification and can be used for input tax deduction.',
      },
      rules: {
        titleRequired: 'Please enter invoice header',
        taxNumberRequired: 'Please enter tax number',
        realNameRequired: 'Please enter real name',
        idNumberRequired: 'Please enter ID number',
      },
      placeholders: {
        title: 'Please enter invoice header',
        taxNumber: 'Please enter tax number',
        bankName: 'Please enter bank name',
        bankAccount: 'Please enter bank account',
        address: 'Please enter registered address',
        phone: 'Please enter registered phone',
        realName: 'Please enter real name',
        idNumber: 'Please enter ID number',
      },
      buttons: {
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      messages: {
        updateSuccess: 'Invoice information updated successfully',
      },
    },
    email: {
      title: 'Email',
      addEmail: 'Add Email',
      maxLimit: 'You can add up to 50 emails',
      table: {
        email: 'Email',
        defaultEmail: 'Default Email',
        action: 'Action',
        setDefault: 'Set as Default',
        edit: 'Edit',
        delete: 'Delete',
      },
      messages: {
        setDefaultSuccess: 'Set default email successfully',
        setDefaultFailed: 'Failed to set default email',
        addSuccess: 'Email added successfully',
        addFailed: 'Failed to add email',
        editSuccess: 'Email updated successfully',
        editFailed: 'Failed to update email',
        deleteSuccess: 'Email deleted successfully',
        deleteFailed: 'Failed to delete email',
      },
      modals: {
        addTitle: 'Add Email',
        editTitle: 'Edit Email',
        deleteTitle: 'Information',
        emailLabel: 'Email',
        emailRequired: 'Please enter email',
        emailInvalid: 'Please enter a valid email address',
        emailPlaceholder: 'Please enter email address',
        isDefault: 'Set as Default',
        cancel: 'Cancel',
        confirm: 'Confirm',
        confirmDelete: 'Confirm Delete',
        deleteConfirm: 'Are you sure you want to delete the following email?',
      },
    },
    adminInvoiceDetail: {
      title: 'Invoice Management/Invoice Detail',
      detailTitle: 'Invoice Details',
      exportButton: 'Export Details',
      fields: {
        title: 'Invoice Header',
        issueType: 'Issue Type',
        invoiceType: 'Invoice Type',
        normalInvoice: 'Normal Invoice',
        vatInvoice: 'VAT Invoice',
        amount: 'Invoice Amount',
        taxRate: 'Tax Rate',
        taxRateValue: '6%',
        medium: 'Invoice Medium',
        onlineInvoice: 'Digital Invoice',
        paperInvoice: 'Paper Invoice',
        comment: 'Comment',
        applyTime: 'Application Time',
        taxInfo: 'Tax Information',
      },
      table: {
        servicePeriod: 'Service Period',
        productName: 'Product Name',
        productType: 'Product Type',
        consumeTime: 'Consumption Time (UTC+8)',
        tradeTime: 'Transaction Time (UTC+8)',
        orderId: 'Order ID',
        billKind: 'Bill Type',
        amount: 'Invoiceable Amount',
      },
      pagination: {
        total: 'Total {{total}} items',
      },
      messages: {
        fetchDetailError: 'Failed to fetch invoice detail',
        fetchListError: 'Failed to fetch invoice details list',
        exportSuccess: 'Export successful',
        exportError: 'Export failed, please try again later',
      },
    },
    adminInvoiceManagement: {
      title: 'Invoice Management',
      alert: {
        description1: 'When administrators receive invoice applications from users, please verify the relevant information and issue invoices to users after confirming the information is correct.',
        description2: 'After administrators complete [Actual Invoice → Send Email], they can click the [Approve] operation, fill in the invoice number, and mark [Completed].',
        description3: 'If the information is incorrect, please fill in the reason and perform the [Reject] operation.',
        description4: 'All applications must be processed within 72 hours [including approval/rejection]',
      },
      filters: {
        category: 'Issue Type',
        invoiceType: 'Invoice Type',
        status: 'Invoice Status',
        placeholder: 'Please select',
      },
      table: {
        applyTime: 'Application Time (UTC+8)',
        title: 'Invoice Header',
        category: 'Issue Type',
        invoiceType: 'Invoice Type',
        medium: 'Invoice Medium',
        amount: 'Invoice Amount',
        status: 'Status',
        operator: 'Operator',
        operateTime: 'Operation Time',
        action: 'Action',
        detail: 'Detail',
        approve: 'Approve',
        reject: 'Reject',
      },
      status: {
        processing: 'Processing',
        completed: 'Completed',
        failed: 'Failed',
      },
      pagination: {
        total: 'Total {{total}} records',
      },
      modals: {
        confirm: 'Confirm',
        cancel: 'Cancel',
        approve: {
          title: 'Approve Invoice',
          invoiceNumber: 'Invoice Number',
          invoiceNumberRequired: 'Please enter invoice number',
          invoiceNumberPlaceholder: 'Please fill in',
        },
        reject: {
          title: 'Reject Invoice',
          rejectReason: 'Reject Reason:',
          rejectReasonRequired: 'Please enter reject reason',
          rejectReasonPlaceholder: 'Please fill in reject reason',
        },
      },
      messages: {
        approveSuccess: 'Approve operation successful',
        approveError: 'Approve operation failed',
        rejectSuccess: 'Reject operation successful',
        rejectError: 'Reject operation failed',
      },
    },
  },
  billOverview: {
    amount: {
      payable: 'Payable Amount',
      actual: 'Actual Amount',
    },
    orderDetail: 'Order Details',
    payOrder: 'Payment Order',
    resourceType: {
      ecs: 'Virtual Machine',
      baremetal: 'Bare Metal',
      disk: 'Disk',
    },
    table: {
      productName: 'Product Name',
      productType: 'Product Type',
      region: 'Available Region',
      cluster: 'Resource Cluster',
      duration: 'Purchase Duration',
      durationHourly: 'Hourly',
      durationMonthly: 'Monthly',
      durationAnnual: 'Annual',
      quantity: 'Purchase Quantity',
      timeRange: 'Time Range',
      originalPrice: 'Original Price',
      discountedPrice: 'Discounted Price',
      couponDiscount: 'Coupon Discount',
      payableAmount: 'Payable Amount',
      actualAmount: 'Actual Amount',
      modelUnit: '/million tokens',
    },
  },
  history: {
    title: 'Recharge History',
    alert: {
      description:
        'Recharge history includes successful, failed, pending, and canceled recharge records. Only successful recharge records will be reflected in the transaction details.',
    },
    table: {
      account: 'Account',
      rechargeId: 'Recharge ID',
      paymentMethod: 'Payment Method',
      rechargeAccount: 'Recharge Account',
      action: 'Action',
      detail: 'Detail',
      pay: 'Pay',
      cancel: 'Cancel',
    },
    paymentMethod: {
      ALIPAY: 'Alipay',
      INTERNAL: 'Balance Payment',
      EXTERNAL: 'Balance Recharge',
    },
    modal: {
      confirmCancel: 'Confirm Cancel',
      confirmCancelContent:
        'Are you sure you want to cancel recharge order {id}?',
      cancelSuccess: 'Order has been canceled',
      cancelFailed: 'Failed to cancel order, please try again',
      payFailed: 'Payment failed, please try again',
    },
  },
  bills: {
    table: {
      productName: 'Product Name',
      productId: 'Product ID',
      originalPrice: 'Original Price',
      discountedPrice: 'Discounted Price',
      couponDiscount: 'Coupon Discount',
      payableAmount: 'Payable Amount',
      detail: 'Detail',
      pay: 'Pay',
      cancel: 'Cancel',
    },
    modal: {
      title: 'Payment Order {id}',
      payableAmount: 'Payable Amount',
      orderType: 'Order Type',
      confirmCancel: 'Confirm Cancel',
      confirmCancelContent:
        'Are you sure you want to cancel recharge order {id}?',
      cancelSuccess: 'Order has been canceled',
      cancelFailed: 'Failed to cancel order, please try again',
    },
  },
  orderFilter: {
    createTimeRange: 'Create Time Range',
    productName: 'Product Name',
    orderStatus: 'Order Status',
    orderType: 'Order Type',
    allOrderStatus: 'All Order Status',
    allOrderType: 'All Order Type',
    inputProductName: 'Please enter product name',
    selectOrderStatus: 'Please select order status',
    selectOrderType: 'Please select order type',
  },
  billReport: {
    title: 'Bill Overview',
    alert: {
      description1:
        'Current month data query results are for reference only and should not be used as reconciliation basis. Final bills for the current month can be viewed/exported after 12:00 PM on the 2nd of the following month.',
      description2: 'Bills are deducted in the order of billing after the bills are issued.',
      description3: 'Priority to deduct vouchers, the remaining part uses account balance to deduct.',
      description4: 'User recharge will be used to pay off the unpaid bills in the order of billing.',  
    },
    tabs: {
      monthlyOverview: 'Monthly Bill Overview',
      monthlyHistory: 'Monthly Bill History',
    },
  },
  monthlyBillOverview: {
    title: 'Monthly Bill Overview',
    monthSelector: 'Bill Month:',
    overview: 'Monthly Overview',
    overviewTitle: 'Month Overview',
    billingCycle: 'Billing Cycle:',
    to: 'to',
    status: {
      billed: 'Billed',
      pending: 'Pending',
    },
    exportBill: 'Export Bill',
    exportSuccess: 'Export successful',
    exportError: 'Export failed, please try again later',
    payableAmount: 'Payable Amount',
    tabs: {
      accountSummary: 'Account Summary by Resource Purchase',
      productSummary: 'Product Summary',
    },
    table: {
      resourcePurchaseAccount: 'Resource Purchase Account',
      billingPeriod: 'Billing Period',
      catalogTotalPrice: 'Catalog Total Price (Original)',
      discountedPrice: 'Discounted Price',
      voucherDeduction: 'Voucher Deduction',
      payableAmount: 'Payable Amount',
      productType: 'Product Type',
      billingMode: 'Billing Mode',
      feeType: 'Fee Type',
      prepaid: 'Prepaid',
      postpaid: 'Postpaid',
    },
  },
  monthlyBillHistory: {
    title: 'Monthly Bill History',
    billingPeriod: 'Billing Period:',
    resourcePurchaseAccount: 'Resource Purchase Account:',
    dateRangePlaceholder: {
      startMonth: 'Start Month',
      endMonth: 'End Month',
    },
    maxQueryWarning: 'Maximum query period is 12 months',
    table: {
      resourcePurchaseAccount: 'Resource Purchase Account',
      billingPeriod: 'Billing Period',
      catalogTotalPrice: 'Catalog Total Price (Original)',
      discountedPrice: 'Discounted Price',
      voucherDeduction: 'Voucher Deduction',
      payableAmount: 'Payable Amount',
      status: 'Status',
      action: 'Action',
      detail: 'Detail',
    },
    status: {
      billed: 'Billed',
      pending: 'Pending',
    },
    pagination: {
      total: 'Total {total} items',
    },
  },
  accountSelector: {
    placeholder: 'Please select resource purchase account',
    all: 'All',
  },
  billCycle: {
    title: 'Bill Details',
    alert: {
      description1:
        'Current month data query results are for reference only and should not be used as reconciliation basis. Final bills for the current month can be viewed/exported after 12:00 PM on the 2nd of the following month.',
      description2: 'Bills that have been charged support invoice generation.',
    },
    tabs: {
      orderDetail: 'Order Billing Details',
      billDetail: 'Bill Details',
    },
  },
  orderMonthlyDetail: {
    title: 'Order Monthly Detail',
    filters: {
      billingPeriod: 'Billing Period:',
      resourcePurchaseAccount: 'Resource Purchase Account:',
      orderId: 'Order ID:',
      hideZeroBills: 'Hide Zero Bills',
      dateFormat: 'YYYY-MM',
    },
    placeholders: {
      selectAccount: 'Please select resource purchase account',
      enterOrderId: 'Please enter order ID',
    },
    table: {
      resourcePurchaseAccount: 'Resource Purchase Account',
      orderId: 'Order ID',
      productName: 'Product Name',
      productType: 'Product Type',
      billingCycle: 'Billing Cycle',
      billStartTime: 'Bill Start Time',
      billEndTime: 'Bill End Time',
      tradeTime: 'Trade Time',
      catalogTotalPrice: 'Catalog Total Price (Original)',
      discountedPrice: 'Discounted Price',
      voucherDeduction: 'Voucher Deduction',
      payableAmount: 'Payable Amount',
    },
  },
  billMonthlyDetail: {
    title: 'Bill Monthly Detail',
    filters: {
      billingPeriod: 'Billing Period:',
      resourcePurchaseAccount: 'Resource Purchase Account:',
      project: 'Project:',
      instanceId: 'Instance ID:',
      dateFormat: 'YYYY-MM',
    },
    placeholders: {
      selectAccount: 'Please select resource purchase account',
      enterInstanceId: 'Please enter instance ID',
    },
    table: {
      resourcePurchaseAccount: 'Resource Purchase Account',
      productType: 'Product Type',
      billingMode: 'Billing Mode',
      orderType: 'Order Type',
      usageDuration: 'Usage Duration',
      durationUnit: 'Duration Unit',
      instanceId: 'Instance ID',
      project: 'Project',
      availableRegion: 'Available Region',
      resourceCluster: 'Resource Cluster',
      unitPrice: 'Unit Price',
      usageQuantity: 'Usage Quantity',
      usageUnit: 'Usage Unit',
      catalogTotalPrice: 'Catalog Total Price (Original)',
      discountedPrice: 'Discounted Price',
      voucherDeduction: 'Voucher Deduction',
      payableAmount: 'Payable Amount',
    },
    billingMode: {
      prepaid: 'Prepaid',
      postpaid: 'Postpaid',
    },
    durationUnits: {
      month: 'Month',
      second: 'Second',
      year: 'Year',
      hour: 'Hour',
    },
    messages: {
      fetchDataError: 'Failed to fetch data, please try again',
    },
  },
  workspaceSelector: {
    all: 'All',
    placeholder: 'Please select workspace',
  },
  costReport: {
    title: 'Cost Report',
    monthlyCostTrend: 'Monthly Cost Trend',
    summary: 'Summary',
    costDetails: 'Cost Details',
    tabs: {
      byResourceType: 'By Resource Type',
      byProject: 'By Project',
      byBillingMode: 'By Billing Mode',
      byRegion: 'By Region',
    },
    datePicker: {
      monthFormat: 'YYYY-MM',
      rangePickerPlaceholder: ['Start Month', 'End Month'],
    },
    charts: {
      noData: 'No Data',
      costAmount: 'Cost Amount',
      tooltip: {
        percentage: '%',
        currency: '¥',
      },
      monthlyCostTrend: {
        month: 'Month',
        cost: 'Cost',
        tooltip: {
          cost: 'Cost',
        },
      },
    },
  },
  usageManagement: {
    title: 'Usage Management',
    alert: {
      description1:
        'Usage data is updated every hour and may have a delay of 1-2 hours.',
      description2:
        'Current month data is for reference only and should not be used as reconciliation basis.',
      description3:
        'Final usage data for the current month can be viewed after 12:00 PM on the 2nd of the following month.',
    },
    tabs: {
      compute: 'Compute Resource Usage Analysis',
      storage: 'Storage Resource Usage Analysis',
      task: 'Task Payload Details',
    },
    compute: {
      title: 'Compute Resource Usage Analysis',
      resourceDurationTrend: 'Resource Duration Trend Statistics',
      durationSummary: 'Duration Summary',
      instanceSpec: 'Instance Specification',
      project: 'Project',
      availableRegion: 'Available Region',
      top: 'TOP',
      selectInstanceSpec: 'Please select instance specification',
      selectRegion: 'Please select region',
      selectProject: 'Please select project',
      all: 'All',
      hours: 'hours',
      percentage: '%',
      byInstanceSpec: 'By Instance Specification',
      byProject: 'By Project',
      byAvailableZone: 'By Available Zone',
      byTaskSubmitter: 'By Task Submitter',
      byTaskType: 'By Task Type',
      name: 'Name',
      usageDuration: 'Usage Duration',
      ratio: 'Ratio',
      prepaidUsageDuration: 'Prepaid Usage Duration',
      postpaidUsageDuration: 'Postpaid Usage Duration',
      cardHours: 'Card Hours',
      aiResources: 'AI Resources',
      virtualMachine: 'Virtual Machine',
      bareMetal: 'Bare Metal',
    },
    storage: {
      title: 'Storage Resource Usage Analysis',
      storageResourceTrend: 'Storage Resource Statistics Trend',
      storageTotalCapacityTrend: 'Storage Total Capacity Trend Chart',
      unit: 'GiB * month',
      selectRegion: 'Please select region',
      all: 'All',
      project: 'Project',
      availableRegion: 'Available Region',
      totalCapacity: ' Total Capacity',
      unitLabel: 'Unit',
      month: 'Month',
    },
    task: {
      title: 'Task Payload Details',
      taskId: 'Task ID',
      taskType: 'Task Type',
      resourceSpec: 'Resource Specification',
      specCount: 'Specification Count',
      resourceType: 'Resource Type',
      createTime: 'Create Time',
      startTime: 'Start Time',
      endTime: 'End Time',
      project: 'Project',
      availableRegion: 'Available Region',
      resourceCluster: 'Resource Cluster',
      creator: 'Creator',
      trainTask: 'Training Task',
      containerInstance: 'Container Instance',
      inferenceService: 'Inference Service',
      prepaid: 'Prepaid',
      postpaid: 'Postpaid',
      fetchDataError: 'Failed to fetch task payload data',
    },
    filter: {
      createTimeRange: 'Create Time Range',
      taskType: 'Task Type',
      taskId: 'Task ID',
      creator: 'Creator',
      projectName: 'Project Name',
      inputTaskType: 'Please enter task type',
      inputTaskId: 'Please enter task ID',
      inputCreator: 'Please select creator',
      inputProjectName: 'Please select project',
    },
  },
}

export default translation
